require('./organizationBrowser.i18n.json');
require('./organizationBrowser.tpl.html');
require('./organizationBrowserActionRepository.js');
require('./organizationBrowserActionUtil.js');
require('./organizationRepository.js');
require('./organizationStateModel.js');
require('./organizationUtil.js');
require('./menu/organizationMenuComponent.js');
require('./manageOrganization/manageOrganizationController.js');

/*@ngInject*/
const OrganizationBrowserController = function ($rootScope, $scope, $timeout, $state, $stateParams, advancedFilterType, filterType, advancedFilterMediator, coreConstant, advancedFilterModel, configurationMediator, localization, navigationStateModel, modalUtil, organizationAction, organizationBrowserActionUtil, organizationUtil, configurationActionsUtil, databaseDownloadSectionName, organizationStatus) {

    localization.getTranslationByKey('organizationBrowser').then(function (translations) {

        $scope.viewModel = {
            isLoading: true,
            filterModel: null,
            organizations: [],
            totalOrganizations: 0,
            isGridEmpty: true,
            recordCountText: _.get(translations, 'recordCountText.' + $stateParams.organizationType),
            recordsCountText: _.get(translations, 'recordsCountText.' + $stateParams.organizationType),
            requestParams: {
                key: 'name',
                startIndex: 0,
                pageSize: 25,
                sortType: 'asc'
            },
            shortDateTimeFormat: 'MM/dd/yy hh:mma',
            title: _.get(translations, 'title.' + $stateParams.organizationType),
            codeColumnHeader: _.get(translations, 'columns.code.' + $stateParams.organizationType),
            emptyGridLabel: _.get(translations, 'emptyGrid.' + $stateParams.organizationType),
            organizationTypeString: organizationUtil.getOrganizationTypeString($stateParams.organizationType)
        };
        $scope.viewModel.advancedFilterType = $scope.viewModel.organizationTypeString + ' ' + advancedFilterType.ORGANIZATION_BROWSER;
        $scope.viewModel.advancedFilterTranslationKey = $scope.viewModel.organizationTypeString + 'Browser';

        $scope.actions = [];
        $scope.hiddenInputActions = {};
        $scope.context = {
            identifier: 'organizationBrowser',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            configurationMediator.loadOrganizationActions($stateParams.organizationType).then(function (actions) {
                const allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;

                $scope.hiddenInputActions = {};
                $scope.hiddenInputActions[organizationAction.IMPORT_CARRIER_LOAS] = 'application/xml';
                $scope.hiddenInputActions[organizationAction.IMPORT_MGA_CARRIER_LOAS] = 'application/xml';

                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        function loadOrganizations() {
            $scope.viewModel.isLoading = true;

            configurationMediator.getOrganizationsByFilterUriAndOrganizationType($scope.viewModel.filterModel.filter.uri, $stateParams.organizationType, $scope.viewModel.requestParams).then(function (organizations) {

                _.each(organizations.records, function (organization) {
                    organization.isDraftStatus = organization.status === organizationStatus.STATUS_DRAFT;
                    organization.name = _.isEmpty(organization.name) ? _.get(translations, 'draftOrganizationName') : organization.name;
                });

                $scope.viewModel.organizations = organizations.records;
                $scope.viewModel.totalOrganizations = organizations.totalRecords;
                $scope.viewModel.isGridEmpty = $scope.viewModel.totalOrganizations === 0;

                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                    $scope.viewModel.isLoading = false;
                }, 0);
            });
        }

        function loadFilter() {
            const existingFilterModel = advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType);
            if (!_.isNil(existingFilterModel) && !_.isNil(existingFilterModel.filter)) {
                $scope.viewModel.filterModel = existingFilterModel;
                loadOrganizations();
            } else {
                advancedFilterMediator.getFilters(filterType.TYPE_ORGANIZATION_FILTER).then(function (filters) {
                    const filter = _.first(filters);
                    if (filter) {
                        advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
                            advancedFilterModel.buildFilter($scope.viewModel.advancedFilterType, filterTemplate, filter, true);
                            $scope.viewModel.filterModel = advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType);
                            loadOrganizations();
                        });
                    }
                });
            }
        }

        function handleFilterSave(event, filter) {
            advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType).filter = filter;
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
        }

        $scope.$on(coreConstant.event.FILTER_SAVED, handleFilterSave);

        $scope.getStatus = function (item) {
            return _.get(translations, 'status.' + item.status);
        };

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            loadOrganizations();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            loadOrganizations();
        };

        function resetNavigationState() {
            navigationStateModel.saveViewState('configuration.organizationBrowser.' + $scope.viewModel.organizationTypeString, null);
        }

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case organizationAction.NEW_AGENCY_ORGANIZATION:
                    case organizationAction.NEW_CARRIER_ORGANIZATION:
                    case organizationAction.NEW_MGA_AGENCY_ORGANIZATION:
                    case organizationAction.NEW_MGA_CARRIER_ORGANIZATION:
                        organizationBrowserActionUtil.createOrganization($stateParams.organizationType);
                        break;

                    case organizationAction.EXPORT_CARRIER_LOAS:
                        organizationBrowserActionUtil.exportCarrierLOAs(false).then(() => {
                            loadActions();
                        });
                        break;

                    case organizationAction.IMPORT_CARRIER_LOAS:
                        organizationBrowserActionUtil.importCarrierLOAs(file, false).then(() => {
                            loadActions();
                        });
                        break;

                    case organizationAction.EXPORT_MGA_CARRIER_LOAS:
                        organizationBrowserActionUtil.exportCarrierLOAs(true).then(() => {
                            loadActions();
                        });
                        break;

                    case organizationAction.IMPORT_MGA_CARRIER_LOAS:
                        organizationBrowserActionUtil.importCarrierLOAs(file, true).then(() => {
                            loadActions();
                        });
                        break;

                    case organizationAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.ORGANIZATIONS, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.onClickRow = function (event, organization) {
            const navigationModel = {
                parentState: 'configuration.organizationBrowser:' + $stateParams.organizationType,
                currentState: 'configuration.manageOrganization',
                data: {
                    organizationId: organization.id,
                    organizationType: parseInt($stateParams.organizationType)
                }

            };
            $state.go('configuration.manageOrganization', {organizationId: organization.id, organizationType: $stateParams.organizationType});
            navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        };

        loadActions();
        resetNavigationState();
        loadFilter();
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('ums.configuration')
    .controller('organizationBrowserController', OrganizationBrowserController);
